export default function insertScript(src, async = true) {
    return new Promise((resolve, reject) => {
        if (!(typeof src === 'string')) {
            reject();
        }

        let tag = document.createElement('script');

        tag.src = src;
        tag.async = async;

        tag.onload = () => {
            resolve(tag);
        };

        tag.onerror = () => {
            reject();
        };

        document.body.appendChild(tag);
    });
}
